import { render, staticRenderFns } from "./ship.component.vue?vue&type=template&id=1e6f7a59&scoped=true&lang=pug"
import script from "./ship.component.vue?vue&type=script&lang=ts"
export * from "./ship.component.vue?vue&type=script&lang=ts"
import style0 from "./ship.component.vue?vue&type=style&index=0&id=1e6f7a59&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6f7a59",
  null
  
)

export default component.exports